import { createSlice } from "@reduxjs/toolkit";
import {
  GET_MARKET_WORKING_SUCCESS,
  GET_MARKET_WORKING_FAIL,
  GET_BAR_GRAPH_SUCCESS,
  GET_BAR_GRAPH_FAIL,
  GET_CHECKIN_DETAILS_SUCCESS,
  GET_CHECKIN_DETAILS_FAIL,
  GET_WSS_CHECKIN_DETAILS_SUCCESS,
  GET_WSS_CHECKIN_DETAILS_FAIL,
  GET_UPCOMING_TOUR_PLAN_SUCCESS,
  GET_UPCOMING_TOUR_PLAN_FAIL,
  GET_PASTINSIGHTS_DETAILS_SUCCESS,
  GET_PASTINSIGHTS_DETAILS_FAIL,
  GET_FEEDBACK_DETAILS_SUCCESS,
  GET_FEEDBACK_DETAILS_FAIL,
} from "../constants/action-types";

// --- Market Working Slice ---
const marketWorkingSlice = createSlice({
  name: "marketWorking",
  initialState: { marketWorkingDetails: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_MARKET_WORKING_SUCCESS, (state, { payload }) => {
        state.marketWorkingDetails = payload;
      })
      .addCase(GET_MARKET_WORKING_FAIL, (state) => {
        state.marketWorkingDetails = "";
      });
  },
});

// --- Bar Graph Slice ---
const barGraphSlice = createSlice({
  name: "barGraph",
  initialState: { graph: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_BAR_GRAPH_SUCCESS, (state, { payload }) => {
        state.graph = payload;
      })
      .addCase(GET_BAR_GRAPH_FAIL, (state) => {
        state.graph = "";
      });
  },
});

// --- Visit Details Slice ---
const visitDetailsSlice = createSlice({
  name: "visitDetails",
  initialState: { checkInDetails: [], checkInWSSDetails: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_CHECKIN_DETAILS_SUCCESS, (state, { payload }) => {
        state.checkInDetails = payload;
      })
      .addCase(GET_CHECKIN_DETAILS_FAIL, (state) => {
        state.checkInDetails = "";
      })
      .addCase(GET_WSS_CHECKIN_DETAILS_SUCCESS, (state, { payload }) => {
        state.checkInWSSDetails = payload;
      })
      .addCase(GET_WSS_CHECKIN_DETAILS_FAIL, (state) => {
        state.checkInWSSDetails = "";
      });
  },
});

// --- Upcoming Tour Plan Slice ---
const upcomingTourPlanSlice = createSlice({
  name: "upcomingTourPlan",
  initialState: { upcomingTourDetails: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_UPCOMING_TOUR_PLAN_SUCCESS, (state, { payload }) => {
        state.upcomingTourDetails = payload;
      })
      .addCase(GET_UPCOMING_TOUR_PLAN_FAIL, (state) => {
        state.upcomingTourDetails = "";
      });
  },
});

// --- Past Insight Slice ---
const pastInsightSlice = createSlice({
  name: "pastInsight",
  initialState: { pastInsightDetails: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_PASTINSIGHTS_DETAILS_SUCCESS, (state, { payload }) => {
        state.pastInsightDetails = payload;
      })
      .addCase(GET_PASTINSIGHTS_DETAILS_FAIL, (state) => {
        state.pastInsightDetails = "";
      });
  },
});

// --- Feedback Slice ---
const feedbackSlice = createSlice({
  name: "getFeedback",
  initialState: { getFeedbackDetails: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_FEEDBACK_DETAILS_SUCCESS, (state, { payload }) => {
        state.getFeedbackDetails = payload;
      })
      .addCase(GET_FEEDBACK_DETAILS_FAIL, (state) => {
        state.getFeedbackDetails = "";
      });
  },
});

export const marketWorkingReducer = marketWorkingSlice.reducer;
export const barGraphReducer = barGraphSlice.reducer;
export const visitDetailsReducer = visitDetailsSlice.reducer;
export const upcomingTourPlanReducer = upcomingTourPlanSlice.reducer;
export const pastInsightReducer = pastInsightSlice.reducer;
export const getFeedbackReducer = feedbackSlice.reducer;
